import { Box, Button, Grid, Modal, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from 'icons/fds';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RichTextWithEmbeds } from 'components/RichText';
import { hasContent } from 'utils/hasContent';

export const useStyles = makeStyles(theme => ({
  modalBox: {
    position: 'absolute',
    width: 'calc(100% - 16px)',
    maxWidth: '520px',
    left: '50%',
    top: '200px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    borderRadius: theme.misc.borderRadius,
  },
  closeIcon: {
    color: theme.palette.common.gray800,
    fontSize: 16,
    margin: theme.spacing(0.25, 0, 0, 0),
    cursor: 'pointer',
  },
  modalBody: {
    padding: theme.spacing(4, 0, 4, 0),
  },
}));

export interface DuplicateApplicantModalProps {
  handleClose: () => void;
  handleCancel?: () => void;
  handleSubmit: () => void;
  modalContentText: string;
  cancelButtonText: string;
  duplicateMessage?: string;
}

export const DuplicateApplicantModal: React.VFC<
  DuplicateApplicantModalProps
> = ({
  handleClose,
  handleCancel,
  handleSubmit,
  modalContentText,
  cancelButtonText,
  duplicateMessage,
}) => {
  const styles = useStyles();

  const hasCustomContent = duplicateMessage && hasContent(duplicateMessage);

  return (
    <Modal open>
      <Box className={styles.modalBox}>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <Typography variant="h3">
              {hasCustomContent ? (
                <FormattedMessage
                  defaultMessage="You’ve already applied"
                  description="Heading text to indicate to applicant they've already applied"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Continue previous application?"
                  description="Heading text to continue previous application"
                />
              )}
            </Typography>
          </Box>
          <Box>
            <Close className={styles.closeIcon} onClick={handleClose} />
          </Box>
        </Box>
        <Box className={styles.modalBody}>
          {hasCustomContent ? (
            <RichTextWithEmbeds text={duplicateMessage} />
          ) : (
            modalContentText
          )}
        </Box>

        <Grid container justify="flex-end" alignItems="center" spacing={2}>
          <Grid item>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleCancel ?? handleClose}
            >
              {cancelButtonText}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleSubmit}
            >
              {hasCustomContent ? (
                <FormattedMessage
                  defaultMessage="Return to previous application"
                  description="Button to prompt user to return to existing application"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Yes, send my link"
                  description="Confirmation to send link"
                />
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
